import {create} from 'zustand';

type ScrollRootsState = {
  /** Panel workspace column scroll container (see PanelBankLayout). */
  panelBankScrollRoot: HTMLElement | null;
  setPanelBankScrollRoot: (panelBankScrollRoot: HTMLElement | null) => void;
};

const useScrollRootsStore = create<ScrollRootsState>(set => ({
  panelBankScrollRoot: null,
  setPanelBankScrollRoot: (panelBankScrollRoot: HTMLElement | null) =>
    set({panelBankScrollRoot}),
}));

export const usePanelBankScrollRoot = () => {
  return useScrollRootsStore(state => state.panelBankScrollRoot);
};

export const useSetPanelBankScrollRoot = () => {
  return useScrollRootsStore(state => state.setPanelBankScrollRoot);
};
